import { usePurchaseFlow } from "@contexts/PurchaseFlowContext";
import { Box, Grid, Stack, Step, StepLabel, Stepper, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import CurrencySelector from "./CurrencySelector";

export default function Header() {
  const { stepLabels, activeStepIndex } = usePurchaseFlow();
  const location = useLocation();

  // Hide stepper on purchase complete page
  const isPurchaseCompletePage = location.pathname.includes("/purchase-complete");

  return (
    <Box sx={{ backgroundColor: "#fff", borderBottom: "1px solid #e0e0e0", pb: 2 }}>
      <Box
        sx={{
          backgroundColor: "#008080",
          height: "3rem",
          marginBottom: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          px: 3,
        }}
      >
        <CurrencySelector />
      </Box>
      <Grid container alignItems="center" maxWidth="100%" direction={{ xs: "column", md: "row" }}>
        <Grid size={{ xs: 12, md: "grow" }}>
          <Stack
            direction="row"
            p={2}
            spacing={2}
            alignItems="flex-start"
            justifyContent="flex-start"
          >
            <img src="/images/unyte-logo.png" alt="Logo" style={{ width: "100px" }} />
            <Typography variant="h6" color="#a7adaa" sx={{ pt: "13px" }}>
              Secure Checkout
            </Typography>
          </Stack>
        </Grid>

        {!isPurchaseCompletePage && (
          <Grid
            size={{ xs: 12, md: "grow" }}
            sx={{
              width: { xs: "100%", md: "auto" },
              alignItems: "center",
            }}
          >
            <Stepper activeStep={activeStepIndex} alternativeLabel>
              {stepLabels.map((label) => (
                <Step key={label}>
                  <StepLabel sx={{ fontWeight: 500 }}>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </Grid>
        )}

        <Grid size="grow" />
      </Grid>
    </Box>
  );
}
